import PermissionedBlock from './PermissionedBlock';

export default PermissionedBlock;
